import React from 'react'
import './subtask-2023.css'
import { freshSubSubtask } from '../../AdminTasks/adminTaskUtils'
import SubSubtask2023 from './SubSubtask2023/SubSubtask2023'

const Subtask2023 = ({subtask, setOpenModal2023, imEditingATemplate}) => {
    const changeSubtaskName = (val) => {
        setOpenModal2023(prev => ({...prev, todoSubtasks: prev.todoSubtasks.map((sub) => sub.subtaskId === subtask.subtaskId ? {...sub, subtaskName: val} : sub)}))
    }

    const toggleCheckmark = () => {
        imEditingATemplate ? setOpenModal2023(prev => ({...prev, todoSubtasks: prev.todoSubtasks.filter((sub) => sub.subtaskId !== subtask.subtaskId && sub )}))
        : setOpenModal2023(prev => ({...prev, todoSubtasks: prev.todoSubtasks.map((sub) => sub.subtaskId === subtask.subtaskId ? {...sub, subtaskCompleted: !sub.subtaskCompleted} : sub )}))
    }

    const addSubSubtask = () => {
        setOpenModal2023(prev => ({...prev, todoSubtasks: prev.todoSubtasks.map((sub) => sub.subtaskId === subtask.subtaskId ? {...sub, subtaskSubtasks: [...sub.subtaskSubtasks, freshSubSubtask()]} : sub )}))
    }

    const checkForAutoClear = (val) => {
        val === "New Subtask" && setOpenModal2023((prev) => ({...prev, todoSubtasks: prev.todoSubtasks.map((sub) => sub.subtaskId === subtask.subtaskId ? {...sub, subtaskName: ''} : sub)}))
    }

    return(
        <div className='subtask-2023__wrapper' style={subtask.subtaskCompleted ? {opacity: 0.35} : {opacity: 1}}>
            <div className='subtask-2023__main-check__wrapper' style={subtask.subtaskCompleted ? {boxShadow: 'none'} : {boxShadow: '0px 0px 10px 1px rgba(0, 0, 0, 0.2)'}}>
                <div className='subtask-2023__check-box' onClick={toggleCheckmark} style={subtask.subtaskCompleted ? {backgroundColor: 'green'} : {backgroundColor: '#fff'} }></div>
                <input className='subtask-2023__subtask-name' value={subtask.subtaskName} onClick={(e) => checkForAutoClear(e.target.value)} onChange={(e) => changeSubtaskName(e.target.value)} />
                <div className='subtask-2023__add-sub-subtask' onClick={addSubSubtask}>+</div>
            </div>
            {subtask.subtaskSubtasks.map((sub2x) => <SubSubtask2023 key={sub2x.subtask2xId} sub2x={sub2x} subtask={subtask} setOpenModal2023={setOpenModal2023} imEditingATemplate={imEditingATemplate} />)}
        </div>
    )
}
export default Subtask2023